import { UILogic } from "@aptus/frontend-core";
import { useRoutes } from "domains";
import { User } from "hooks/users/models/user";
import { SaveUserInput } from "hooks/users/models/userInput";
import { UseFormTypes } from "pages/databasePage/components/databaseContent/recordForm/forms/useFormTypes";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

interface Props {
	initialValues?: User;
	submit: (values: SaveUserInput) => void;
	remove: (id: string) => void;
}

interface Result extends UseFormTypes<User> {
	handleDelete: (id: string) => void;
	cancel: () => void;
}

export const useUserForm: UILogic<Props, Result> = ({ initialValues, submit, remove }) => {
	const { currentQueryString: { selected, create }, updateQueryString } = useRoutes();

	const defaultValues = {
		...initialValues,
		id: selected,
	};

	const { register, handleSubmit, control, reset, formState: { errors } } = useForm<User>({ defaultValues });

	useEffect(() => {
		reset(defaultValues);
	}, [create, initialValues]);

	const handleFormSubmit = (values: User): void => {
		submit(values);
		updateQueryString({ selected: null, create: null });
	};

	const handleDelete = (id: string) => {
		remove(id);
		updateQueryString({ selected: null, create: null });
	};

	const cancel = () => {
		updateQueryString({ selected: null, create: null });
	};

	return {
		register,
		control,
		handleFormSubmit: handleSubmit(handleFormSubmit),
		handleDelete,
		errors,
		cancel,
	};
};
